export default {
  init() {
    this.setupTestimonials();
    // this.setupScrollMagic();
  },
  setupTestimonials() {
    $('.testimonials-slider').slick({
      centerPadding: '0',
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      gap: 20,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
    });
  },
};
